import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import NRRemediateIcon from '../../../NRIcons/NRRemediateIcon';
import { alpha, useTheme } from '@mui/material/styles';

function NRRemediateVulnerabilityButton({ row, handleOnClick = () => {} }) {
  const theme = useTheme();
  return (
    <Tooltip title={'Remediate'}>
      <Button
        sx={{
          color: theme.palette.mode === 'light' ? alpha(theme.palette.secondary.dark, 0.6) : theme.palette.secondary.main,
          width: theme.spacing(16),
          height: theme.spacing(4.5)
        }}
        variant="outlined"
        color="secondary"
        onClick={handleOnClick}
        startIcon={<NRRemediateIcon />}
      >
        Remediate
      </Button>
    </Tooltip>
  );
}
export default NRRemediateVulnerabilityButton;
